import { AUTH_BASE_URL } from '../config/api';

const API_BASE_URL = AUTH_BASE_URL;

// Get all burst modes available to the user
export const fetchBurstModes = async () => {
  const response = await fetch(`${API_BASE_URL}/api/burst-modes`, {
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch burst modes');
  }
  
  return response.json();
};

// Create a new burst mode
export const createBurstMode = async (burstModeData) => {
  const response = await fetch(`${API_BASE_URL}/api/burst-modes`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(burstModeData),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to create burst mode');
  }
  
  return response.json();
};

// Update a burst mode
export const updateBurstMode = async (id, updates) => {
  const response = await fetch(`${API_BASE_URL}/api/burst-modes/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(updates),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to update burst mode');
  }
  
  return response.json();
};

// Delete a burst mode
export const deleteBurstMode = async (id) => {
  const response = await fetch(`${API_BASE_URL}/api/burst-modes/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to delete burst mode');
  }
  
  return response.json();
};

// Get user's app permissions
export const fetchUserPermissions = async () => {
  const response = await fetch(`${API_BASE_URL}/api/permissions`, {
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch user permissions');
  }
  
  return response.json();
};

// Update user permissions (admin only)
export const updateUserPermissions = async (userId, permissions) => {
  const response = await fetch(`${API_BASE_URL}/api/permissions/${userId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(permissions),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to update user permissions');
  }
  
  return response.json();
};